import { render, staticRenderFns } from "./centerHome.vue?vue&type=template&id=3ea36570&scoped=true"
import script from "./centerHome.vue?vue&type=script&lang=js"
export * from "./centerHome.vue?vue&type=script&lang=js"
import style0 from "./centerHome.vue?vue&type=style&index=0&id=3ea36570&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea36570",
  null
  
)

export default component.exports